<template>
  <b-form class="" @submit.prevent="validationForm">
    <!-- username -->
    <b-form-row>
      <b-col>
        <b-form-group label="الاسم الأول" label-for="firstName">
          <validation-provider
            mode="passive"
            #default="{ errors }"
            name="الاسم الأول"
            rules="required|min:2"
          >
            <b-form-input
              id="firstName"
              v-model="form.first_name"
              :state="errors.length > 0 ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="اسم الأب" label-for="fatherName">
          <validation-provider
            mode="passive"
            #default="{ errors }"
            name="اسم الأب"
            rules="required|min:2"
          >
            <b-form-input
              id="fatherName"
              v-model="form.father_name"
              :state="errors.length > 0 ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="الكنية" label-for="lastName">
          <validation-provider
            mode="passive"
            #default="{ errors }"
            name="الكنية"
            rules="required|min:2"
          >
            <b-form-input
              id="lastName"
              v-model="form.last_name"
              :state="errors.length > 0 ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-form-group label="رقم الهاتف" label-for="mobile">
          <validation-provider
            mode="passive"
            #default="{ errors }"
            name="رقم الهاتف"
            rules="required|digits:10|min:10|max:10"
          >
            <cleave
              v-model="form.phone_number"
              id="mobile"
              class="form-control"
              :options="{ numericOnly: true, blocks: [10] }"
              :class="errors.length > 0 ? 'is-invalid' : ''"
            />

            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="الرقم الوطني" label-for="idnum">
          <validation-provider
            mode="passive"
            #default="{ errors }"
            name="الرقم الوطني"
            rules="required|digits:11|min:11|max:11"
          >
            <cleave
              v-model="form.id_number"
              id="idnum"
              class="form-control"
              :options="{ numericOnly: true, blocks: [11] }"
              :class="errors.length > 0 ? 'is-invalid' : ''"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
    </b-form-row>
    <!-- email -->
    <b-form-row>
      <b-col>
        <b-form-group label="البريد الالكتروني" label-for="email">
          <validation-provider
            mode="passive"
            #default="{ errors }"
            name="البريد الالكتروني"
            rules="required|email"
          >
            <b-form-input
              id="email"
              v-model="form.email"
              :state="errors.length > 0 ? false : null"
              name="البريد الالكتروني"
              placeholder="ngo@example.com"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
    </b-form-row>
    <!-- submit button -->
    <!-- <b-button variant="success" block type="submit">إنشاء حساب</b-button> -->
  </b-form>
</template>

<script>
import Cleave from "vue-cleave-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BForm,
  BFormRow,
  BCol,
  BButton,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
} from "bootstrap-vue";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
  max,
} from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";

export default {
  components: {
    VuexyLogo,
    // BSV
    BCard,
    BLink,
    BCardTitle,
    BCardText,
    BForm,
    BFormRow,
    BCol,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    // validations
    ValidationProvider,
    ValidationObserver,
    Cleave,
  },
  mixins: [togglePasswordVisibility],
  props: {
    value: Object,
  },
  data() {
    return {
      regEmail: "",
      username: "",
      password: "",
      status: "",
      confirmFieldType: "password",
      // validation rules
      required,
      email,
      confirmed,
      url,
      between,
      alpha,
      integer,
      password,
      min,
      digits,
      alphaDash,
      length,
      max,
    };
  },
  computed: {
    form: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  methods: {
    validationForm() {
      this.$refs.registerForm.validate().then((success) => {
        if (success) {
          this.$emit("validationSuccess");
          resolve(true);
        } else {
          reject(false);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.auth-wrapper.auth-v1 .auth-inner {
  max-width: 400px !important;
}
</style>
